var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('modal',{attrs:{"name":"offline-modal","transition":"fade","width":"400px","height":"auto","scrollable":false,"clickToClose":false}},[_c('OfflineModalComponent')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }